import { render } from "./DeviceWarning.vue?vue&type=template&id=4b8f6896&scoped=true"
import script from "./DeviceWarning.vue?vue&type=script&lang=js"
export * from "./DeviceWarning.vue?vue&type=script&lang=js"

import "./DeviceWarning.vue?vue&type=style&index=0&id=4b8f6896&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8f6896"]])

export default __exports__